/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnerscolumnevents2Inputs */

const en_partnerscolumnevents2 = /** @type {(inputs: Partnerscolumnevents2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events published`)
};

const de_partnerscolumnevents2 = /** @type {(inputs: Partnerscolumnevents2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events`)
};

/**
* | output |
* | --- |
* | "Events published" |
*
* @param {Partnerscolumnevents2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnerscolumnevents2 = /** @type {((inputs?: Partnerscolumnevents2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnerscolumnevents2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnerscolumnevents2(inputs)
	return de_partnerscolumnevents2(inputs)
});
export { partnerscolumnevents2 as "partnersColumnEvents" }